import { render, staticRenderFns } from "./adultTextList.vue?vue&type=template&id=219aa387&class=full-height&"
import script from "./adultTextList.vue?vue&type=script&lang=js&"
export * from "./adultTextList.vue?vue&type=script&lang=js&"
import style0 from "./adultTextList.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('219aa387')) {
      api.createRecord('219aa387', component.options)
    } else {
      api.reload('219aa387', component.options)
    }
    module.hot.accept("./adultTextList.vue?vue&type=template&id=219aa387&class=full-height&", function () {
      api.rerender('219aa387', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/toursCombine/adultTextBlocking/components/adultTextList.vue"
export default component.exports